import React, { useEffect, useState } from "react";
import { fetchLookbook } from "../lib/api";

export default function Lookbook() {
    const [look, setLook] = useState(null);

    useEffect(() => {
        fetchLookbook().then(setLook).catch(() => {});
    }, []);

    if (!look) {
        return <div className="pt-32 container-rail min-h-[60vh]" />;
    }

    return (
        <div data-testid="lookbook-page" className="pt-28">
            <section className="container-rail pb-10 border-b border-white/5">
                <div className="text-overline text-[#A3A3A3] mb-4">N° 03 · Lookbook · {look.season}</div>
                <h1 className="text-display text-5xl sm:text-6xl md:text-8xl leading-[0.9]">
                    {look.title.split("&")[0].trim()} <span className="text-display-italic">& {look.title.split("&")[1]?.trim()}</span>
                </h1>
                <p className="text-[#A3A3A3] mt-6 max-w-xl leading-relaxed">
                    Photographed in February in Nassau, against the wash of Bahamian light and the bones of an island warehouse. Shot on Mamiya RZ67, available light only.
                    Twenty-one pieces and one architecture.
                </p>
            </section>

            <section className="container-rail py-16">
                <div className="grid grid-cols-12 gap-3 sm:gap-4">
                    {/* Bento layout */}
                    <div className="col-span-12 md:col-span-8 row-span-2">
                        <div className="relative aspect-[4/5] overflow-hidden bg-[#141414] border border-white/[0.06]">
                            <img src={look.images[0]} alt="Look 01" className="h-full w-full object-cover" />
                            <div className="absolute bottom-5 left-5 text-overline text-white/80">N° 01 — Of Concrete</div>
                        </div>
                    </div>
                    <div className="col-span-6 md:col-span-4">
                        <div className="relative aspect-square overflow-hidden bg-[#141414] border border-white/[0.06]">
                            <img src={look.images[1]} alt="Look 02" className="h-full w-full object-cover" />
                            <div className="absolute bottom-3 left-3 text-overline text-white/80">N° 02</div>
                        </div>
                    </div>
                    <div className="col-span-6 md:col-span-4">
                        <div className="relative aspect-square overflow-hidden bg-[#141414] border border-white/[0.06]">
                            <img src={look.images[2]} alt="Look 03" className="h-full w-full object-cover" />
                            <div className="absolute bottom-3 left-3 text-overline text-white/80">N° 03</div>
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-7 md:col-start-1">
                        <div className="relative aspect-[16/10] overflow-hidden bg-[#141414] border border-white/[0.06]">
                            <img src={look.images[3]} alt="Look 04" className="h-full w-full object-cover" />
                            <div className="absolute bottom-5 left-5 text-overline text-white/80">N° 04 — & Silk</div>
                        </div>
                    </div>
                    <div className="col-span-12 md:col-span-5">
                        <div className="h-full flex flex-col justify-center px-2 md:px-8">
                            <div className="text-overline text-[#666] mb-4">Editorial — Notes</div>
                            <p className="text-display text-3xl sm:text-4xl leading-tight">
                                "The body wears nothing — <span className="text-display-italic">the room does.</span>"
                            </p>
                            <div className="text-overline text-[#A3A3A3] mt-6">— L. Marinetti, Photographer</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
